import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalContent from 'components/base/secure/modals/modal-content';
import ModalHeader from 'components/base/secure/modals/modal-header';
import { Trans, withNamespaces } from 'react-i18next';
import { ParentCategory, Subcategory } from 'store/categoryStore';
import { observer } from 'mobx-react';
import CancelButton from 'components/form/cancel-button';
import DeleteButton from 'components/form/delete-button';

@withNamespaces()
@observer
class DeleteCategoryModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
        };

        this.onSubmit = this.onSubmit.bind(this);
        this.dismiss = this.dismiss.bind(this);
    }

    onSubmit(e) {
        e.preventDefault();

        if (this.state.loading) {
            return;
        }

        this.setState({loading: true});

        this.props.category.requestDelete()
            .catch(err => this.setState({loading: false}));
    }

    dismiss() {
        this.props.onClose();
    }

    render() {
        const { loading } = this.state;
        const { t, category } = this.props;

        return (
            <ModalContent>
                <ModalHeader
                    title={t(category.parent ? 'BUDGET.CATEGORY.DELETE_MODAL.SUB_TITLE' : 'BUDGET.CATEGORY.DELETE_MODAL.PAR_TITLE')}
                    close={this.dismiss}
                />
                <div className="modal-body">
                    <form onSubmit={this.onSubmit}>
                        <Trans i18nKey={category.parent ? 'BUDGET.CATEGORY.DELETE_MODAL.SUB_TEXT' : 'BUDGET.CATEGORY.DELETE_MODAL.PAR_TEXT'}>
                            <span style={{fontWeight: '700'}}>{{name: category.name}}</span>
                        </Trans>

                        <div>
                            <div className="modal-footer modal-footer-space">
                                <DeleteButton loading={loading} />
                                <CancelButton loading={loading} onClick={this.dismiss} />
                            </div>
                        </div>
                    </form>
                </div>
            </ModalContent>
        );
    }
}

DeleteCategoryModal.propTypes = {
    /** Category which is being deleted */
    category: PropTypes.oneOfType([
        PropTypes.instanceOf(ParentCategory),
        PropTypes.instanceOf(Subcategory),
    ]).isRequired,

    /** Function that gets executed on close */
    onClose: PropTypes.func.isRequired,
};

export default DeleteCategoryModal;


// WEBPACK FOOTER //
// ./src/modules/budget/components/category/modals/delete-category-modal.js